// src/components/common/ScrollToTop.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * This component scrolls the window to the top (0, 0) whenever the route changes.
 * It should be placed inside the BrowserRouter but outside of any Routes.
 * 
 * This fixes the issue where some pages would start at the bottom of the page
 * instead of the top, which is not standard UI practice.
 * 
 * The component ensures that:
 * 1. When navigating to a new page, the scroll position is reset to the top
 * 2. This applies to all routes including Financials, Reports, Utilities, Register Units, etc.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top of the page immediately when route changes
    // Using requestAnimationFrame to ensure the scroll happens after the DOM updates
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
